import React from 'react';

/**
 * Catches a render error below it and shows a message with a way back,
 * instead of unmounting the whole app to a blank page.  Keyed on the
 * location by the caller, so moving to another screen clears it.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Screen error:', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="p-8 max-w-xl mx-auto text-center" data-testid="screen-error">
        <h2 className="text-lg font-semibold mb-2">This screen hit an error</h2>
        <p className="text-sm mb-4" style={{ color: 'var(--text-muted)' }}>
          {String(this.state.error?.message || this.state.error)}
        </p>
        <button className="px-3 py-1.5 border rounded text-sm mr-2" onClick={() => this.setState({ error: null })}>Try again</button>
        <button className="px-3 py-1.5 border rounded text-sm" onClick={() => { window.location.href = '/dashboard'; }}>Go to dashboard</button>
      </div>
    );
  }
}
